import React, { useState } from "react";
import { useParams } from "react-router-dom";

import Tabs from "../../atoms/Tabs/Tabs";
import AssessmentQnA from "../AssessmentQnA/AssessmentQnA";
import ExerciseAssessmentView from "./ExerciseAssessmentView";

const tabs = [
  { label: "Assessment (New)", value: "ASSESSMENT_NEW" },
  { label: "Assessment (Old)", value: "ASSESSMENT_OLD" },
];

/**
 * Route shell for the exercise-plan iframe in the Angular coach app.
 * The old view stays mounted while hidden: it posts the selected assessment
 * to the parent, which the exercise plan preview reads.
 */
const ExerciseAssessmentTabs: React.FC = () => {
  const params = useParams();
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  // Store the iframe's session before children mount, so their first requests
  // carry this token rather than a stale one.
  useState(() => {
    if (params.patientId && params.token) {
      localStorage.setItem("patient_id", params.patientId);
      localStorage.setItem("token", params.token);
    }
    return null;
  });

  return (
    <div className="exercise-assessment-tabs">
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      <div style={{ padding: "16px" }} hidden={activeTab !== "ASSESSMENT_NEW"}>
        <AssessmentQnA assessmentId="exercise" patientId={params.patientId} />
      </div>
      <div hidden={activeTab !== "ASSESSMENT_OLD"}>
        <ExerciseAssessmentView />
      </div>
    </div>
  );
};

export default ExerciseAssessmentTabs;
